/**
 * PaySuite MFE screens. They are released through the `paymentLinks` ConfigCat flag, so both the
 * routes in App.tsx and the sidebar entries are hidden while the flag is off. The three onboarded
 * screens also require completed onboarding. Receipts is not part of the set — it is always available.
 */
export const paySuiteHrefs = new Set([
  '/payments/onboarding',
  '/payments/dispute',
  '/payments/reporting',
  '/payments/transactions-list',
]);

export const paySuiteOnboardedHrefs = new Set([
  '/payments/dispute',
  '/payments/reporting',
  '/payments/transactions-list',
]);
